import "core-js/modules/esnext.global-this.js";
import * as e from "react";
import n from "react";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _t = function t() {
  return _t = Object.assign || function (e) {
    for (var n, t = 1, r = arguments.length; t < r; t++) {
      for (var o in n = arguments[t]) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  }, _t.apply(this, arguments);
},
    r = function r(e) {
  var n = this;

  this.excerpt = function (e) {
    var t;
    void 0 === e && (e = 156);
    var r = null === (t = n.json) || void 0 === t ? void 0 : t.content,
        o = "";
    return Array.isArray(r) && r.forEach(function (n) {
      if ("paragraph" === n.nodeType) {
        var t = n.content;
        if (Array.isArray(t)) for (var r = 1; o.length < e && r < t.length;) {
          t.forEach(function (e) {
            var n;
            "text" === e.nodeType ? (o += e.value, r++) : (o = Array.isArray(e.content) && e.content[0] && "value" in e.content[0] ? null === (n = e.content[0]) || void 0 === n ? void 0 : n.value : "", r++);
          });
        }
      }
    }), o.length > e ? o.slice(0, e) + "..." : o;
  };

  var r = (null == e ? void 0 : e.references) ? e.references : [],
      o = null == e ? void 0 : e.raw,
      a = o ? JSON.parse(o) : void 0,
      E = 0;
  this.raw = o, this.json = a && Array.isArray(a.content) ? _t(_t({}, a), {
    content: a.content.map(function (e) {
      var n = e.nodeType,
          o = null;

      switch (!0) {
        case Array.isArray(n.match(/^embedded/)):
          o = r[E], E++;
          break;

        case Array.isArray(n.match(/paragraph|heading/)):
          e.content.forEach(function (e) {
            e.nodeType.match(/^entry|asset/) && (o = r[E], E++, e.reference = o);
          });
          break;

        case Array.isArray(n.match(/list/)):
          e.content.forEach(function (e) {
            ("content" in e && Array.isArray(e.content) ? e.content : []).forEach(function (e) {
              e.nodeType.match(/^entry|asset/) && (o = r[E], E++, e.reference = o);
            });
          });
          break;

        case Array.isArray(n.match(/quote/)):
          e.content.forEach(function (e) {
            ("content" in e && Array.isArray(e.content) ? e.content : []).forEach(function (e) {
              e.nodeType.match(/^entry|asset/) && (o = r[E], E++, e.reference = o);
            });
          });
          break;

        case Array.isArray(n.match(/hr/)):
          break;

        default:
          console.log("The node: " + n + " is not yet supported in the RichText class.");
      }

      var a = null == o ? void 0 : o.__typename,
          u = _t({}, o);

      return u && "__typename" in u && delete u.__typename, _t(_t({}, e), {
        reference: {
          __typename: a,
          data: _t({}, u)
        }
      });
    })
  }) : void 0, this.references = r;
},
    o = function o() {
  return n.createElement(n.Fragment, null);
},
    a = function () {
  function e(e, n) {
    var t = null == e ? void 0 : e.reference,
        r = null == t ? void 0 : t.__typename,
        a = null == t ? void 0 : t.data;
    this.props = a, this.Comp = r ? function (e) {
      var t = e in n ? n[e] : void 0;
      return t || console.log("No component ".concat(e, " defined in component hash table")), t || o;
    }(r) : o, this.hash = n;
  }

  return e.prototype.render = function () {
    var e = this.Comp,
        r = this.props;
    return n.createElement(e, _t({}, r));
  }, e.prototype.setComp = function (e) {
    this.Comp = e || o;
  }, e;
}(),
    E = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    u = {};

!function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var t,
      r = n,
      o = (t = r) && "object" == typeof t && "default" in t ? t.default : t,
      _a = function a() {
    return _a = Object.assign || function (e) {
      for (var n, t = 1, r = arguments.length; t < r; t++) {
        for (var o in n = arguments[t]) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }

      return e;
    }, _a.apply(this, arguments);
  },
      u = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== E ? E : "undefined" != typeof self ? self : {};

  function l(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }

  function i(e, n) {
    return e(n = {
      exports: {}
    }, n.exports), n.exports;
  }

  var c = i(function (e, n) {
    var t;
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.BLOCKS = void 0, (t = n.BLOCKS || (n.BLOCKS = {})).DOCUMENT = "document", t.PARAGRAPH = "paragraph", t.HEADING_1 = "heading-1", t.HEADING_2 = "heading-2", t.HEADING_3 = "heading-3", t.HEADING_4 = "heading-4", t.HEADING_5 = "heading-5", t.HEADING_6 = "heading-6", t.OL_LIST = "ordered-list", t.UL_LIST = "unordered-list", t.LIST_ITEM = "list-item", t.HR = "hr", t.QUOTE = "blockquote", t.EMBEDDED_ENTRY = "embedded-entry-block", t.EMBEDDED_ASSET = "embedded-asset-block", t.TABLE = "table", t.TABLE_ROW = "table-row", t.TABLE_CELL = "table-cell", t.TABLE_HEADER_CELL = "table-header-cell";
  });
  l(c), c.BLOCKS;
  var L = i(function (e, n) {
    var t;
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.INLINES = void 0, (t = n.INLINES || (n.INLINES = {})).HYPERLINK = "hyperlink", t.ENTRY_HYPERLINK = "entry-hyperlink", t.ASSET_HYPERLINK = "asset-hyperlink", t.EMBEDDED_ENTRY = "embedded-entry-inline";
  });
  l(L), L.INLINES;

  var _ = i(function (e, n) {
    var t;
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), function (e) {
      e.BOLD = "bold", e.ITALIC = "italic", e.UNDERLINE = "underline", e.CODE = "code";
    }(t || (t = {})), n.default = t;
  });

  l(_);
  var O = i(function (e, n) {
    var t,
        r = u && u.__spreadArray || function (e, n, t) {
      if (t || 2 === arguments.length) for (var r, o = 0, a = n.length; o < a; o++) {
        !r && o in n || (r || (r = Array.prototype.slice.call(n, 0, o)), r[o] = n[o]);
      }
      return e.concat(r || Array.prototype.slice.call(n));
    };

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.V1_NODE_TYPES = n.TEXT_CONTAINERS = n.HEADINGS = n.CONTAINERS = n.VOID_BLOCKS = n.TABLE_BLOCKS = n.LIST_ITEM_BLOCKS = n.TOP_LEVEL_BLOCKS = void 0, n.TOP_LEVEL_BLOCKS = [c.BLOCKS.PARAGRAPH, c.BLOCKS.HEADING_1, c.BLOCKS.HEADING_2, c.BLOCKS.HEADING_3, c.BLOCKS.HEADING_4, c.BLOCKS.HEADING_5, c.BLOCKS.HEADING_6, c.BLOCKS.OL_LIST, c.BLOCKS.UL_LIST, c.BLOCKS.HR, c.BLOCKS.QUOTE, c.BLOCKS.EMBEDDED_ENTRY, c.BLOCKS.EMBEDDED_ASSET, c.BLOCKS.TABLE], n.LIST_ITEM_BLOCKS = [c.BLOCKS.PARAGRAPH, c.BLOCKS.HEADING_1, c.BLOCKS.HEADING_2, c.BLOCKS.HEADING_3, c.BLOCKS.HEADING_4, c.BLOCKS.HEADING_5, c.BLOCKS.HEADING_6, c.BLOCKS.OL_LIST, c.BLOCKS.UL_LIST, c.BLOCKS.HR, c.BLOCKS.QUOTE, c.BLOCKS.EMBEDDED_ENTRY, c.BLOCKS.EMBEDDED_ASSET], n.TABLE_BLOCKS = [c.BLOCKS.TABLE, c.BLOCKS.TABLE_ROW, c.BLOCKS.TABLE_CELL, c.BLOCKS.TABLE_HEADER_CELL], n.VOID_BLOCKS = [c.BLOCKS.HR, c.BLOCKS.EMBEDDED_ENTRY, c.BLOCKS.EMBEDDED_ASSET], n.CONTAINERS = ((t = {})[c.BLOCKS.OL_LIST] = [c.BLOCKS.LIST_ITEM], t[c.BLOCKS.UL_LIST] = [c.BLOCKS.LIST_ITEM], t[c.BLOCKS.LIST_ITEM] = n.LIST_ITEM_BLOCKS, t[c.BLOCKS.QUOTE] = [c.BLOCKS.PARAGRAPH], t[c.BLOCKS.TABLE] = [c.BLOCKS.TABLE_ROW], t[c.BLOCKS.TABLE_ROW] = [c.BLOCKS.TABLE_CELL, c.BLOCKS.TABLE_HEADER_CELL], t[c.BLOCKS.TABLE_CELL] = [c.BLOCKS.PARAGRAPH], t[c.BLOCKS.TABLE_HEADER_CELL] = [c.BLOCKS.PARAGRAPH], t), n.HEADINGS = [c.BLOCKS.HEADING_1, c.BLOCKS.HEADING_2, c.BLOCKS.HEADING_3, c.BLOCKS.HEADING_4, c.BLOCKS.HEADING_5, c.BLOCKS.HEADING_6], n.TEXT_CONTAINERS = r([c.BLOCKS.PARAGRAPH], n.HEADINGS, !0), n.V1_NODE_TYPES = [c.BLOCKS.DOCUMENT, c.BLOCKS.PARAGRAPH, c.BLOCKS.HEADING_1, c.BLOCKS.HEADING_2, c.BLOCKS.HEADING_3, c.BLOCKS.HEADING_4, c.BLOCKS.HEADING_5, c.BLOCKS.HEADING_6, c.BLOCKS.OL_LIST, c.BLOCKS.UL_LIST, c.BLOCKS.LIST_ITEM, c.BLOCKS.HR, c.BLOCKS.QUOTE, c.BLOCKS.EMBEDDED_ENTRY, c.BLOCKS.EMBEDDED_ASSET, L.INLINES.HYPERLINK, L.INLINES.ENTRY_HYPERLINK, L.INLINES.ASSET_HYPERLINK, L.INLINES.EMBEDDED_ENTRY, "text"];
  });
  l(O), O.V1_NODE_TYPES, O.TEXT_CONTAINERS, O.HEADINGS, O.CONTAINERS, O.VOID_BLOCKS, O.TABLE_BLOCKS, O.LIST_ITEM_BLOCKS, O.TOP_LEVEL_BLOCKS;
  var f = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
  });
  l(f);
  var d = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
  });
  l(d);
  var S = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    var t = {
      nodeType: c.BLOCKS.DOCUMENT,
      data: {},
      content: [{
        nodeType: c.BLOCKS.PARAGRAPH,
        data: {},
        content: [{
          nodeType: "text",
          value: "",
          marks: [],
          data: {}
        }]
      }]
    };
    n.default = t;
  });
  l(S);
  var T = i(function (e, n) {
    function t(e, n) {
      for (var t = 0, r = Object.keys(e); t < r.length; t++) {
        if (n === e[r[t]]) return !0;
      }

      return !1;
    }

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.isText = n.isBlock = n.isInline = void 0, n.isInline = function (e) {
      return t(L.INLINES, e.nodeType);
    }, n.isBlock = function (e) {
      return t(c.BLOCKS, e.nodeType);
    }, n.isText = function (e) {
      return "text" === e.nodeType;
    };
  });
  l(T), T.isText, T.isBlock, T.isInline;
  var A = i(function (e, n) {
    var t = u && u.__createBinding || (Object.create ? function (e, n, t, r) {
      void 0 === r && (r = t), Object.defineProperty(e, r, {
        enumerable: !0,
        get: function get() {
          return n[t];
        }
      });
    } : function (e, n, t, r) {
      void 0 === r && (r = t), e[r] = n[t];
    }),
        r = u && u.__setModuleDefault || (Object.create ? function (e, n) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: n
      });
    } : function (e, n) {
      e.default = n;
    }),
        o = u && u.__exportStar || function (e, n) {
      for (var r in e) {
        "default" === r || Object.prototype.hasOwnProperty.call(n, r) || t(n, e, r);
      }
    },
        a = u && u.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var n = {};
      if (null != e) for (var o in e) {
        "default" !== o && Object.prototype.hasOwnProperty.call(e, o) && t(n, e, o);
      }
      return r(n, e), n;
    },
        E = u && u.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.helpers = n.EMPTY_DOCUMENT = n.MARKS = n.INLINES = n.BLOCKS = void 0, Object.defineProperty(n, "BLOCKS", {
      enumerable: !0,
      get: function get() {
        return c.BLOCKS;
      }
    }), Object.defineProperty(n, "INLINES", {
      enumerable: !0,
      get: function get() {
        return L.INLINES;
      }
    }), Object.defineProperty(n, "MARKS", {
      enumerable: !0,
      get: function get() {
        return E(_).default;
      }
    }), o(O, n), o(f, n), o(d, n), Object.defineProperty(n, "EMPTY_DOCUMENT", {
      enumerable: !0,
      get: function get() {
        return E(S).default;
      }
    });
    var l = a(T);
    n.helpers = l;
  });
  l(A);
  var B = A.helpers;
  A.EMPTY_DOCUMENT;
  var C,
      I,
      s = A.MARKS,
      N = A.INLINES,
      p = A.BLOCKS;

  function D(e, n) {
    return e.map(function (e, t) {
      return o = K(e, n), a = t, r.isValidElement(o) && null === o.key ? r.cloneElement(o, {
        key: a
      }) : o;
      var o, a;
    });
  }

  function K(e, n) {
    var t = n.renderNode,
        r = n.renderMark,
        a = n.renderText;
    if (B.isText(e)) return e.marks.reduce(function (e, n) {
      return r[n.type] ? r[n.type](e) : e;
    }, a ? a(e.value) : e.value);
    var E = D(e.content, n);
    return e.nodeType && t[e.nodeType] ? t[e.nodeType](e, E) : o.createElement(o.Fragment, null, E);
  }

  var y = ((C = {})[p.DOCUMENT] = function (e, n) {
    return n;
  }, C[p.PARAGRAPH] = function (e, n) {
    return o.createElement("p", null, n);
  }, C[p.HEADING_1] = function (e, n) {
    return o.createElement("h1", null, n);
  }, C[p.HEADING_2] = function (e, n) {
    return o.createElement("h2", null, n);
  }, C[p.HEADING_3] = function (e, n) {
    return o.createElement("h3", null, n);
  }, C[p.HEADING_4] = function (e, n) {
    return o.createElement("h4", null, n);
  }, C[p.HEADING_5] = function (e, n) {
    return o.createElement("h5", null, n);
  }, C[p.HEADING_6] = function (e, n) {
    return o.createElement("h6", null, n);
  }, C[p.EMBEDDED_ENTRY] = function (e, n) {
    return o.createElement("div", null, n);
  }, C[p.UL_LIST] = function (e, n) {
    return o.createElement("ul", null, n);
  }, C[p.OL_LIST] = function (e, n) {
    return o.createElement("ol", null, n);
  }, C[p.LIST_ITEM] = function (e, n) {
    return o.createElement("li", null, n);
  }, C[p.QUOTE] = function (e, n) {
    return o.createElement("blockquote", null, n);
  }, C[p.HR] = function () {
    return o.createElement("hr", null);
  }, C[p.TABLE] = function (e, n) {
    return o.createElement("table", null, o.createElement("tbody", null, n));
  }, C[p.TABLE_ROW] = function (e, n) {
    return o.createElement("tr", null, n);
  }, C[p.TABLE_HEADER_CELL] = function (e, n) {
    return o.createElement("th", null, n);
  }, C[p.TABLE_CELL] = function (e, n) {
    return o.createElement("td", null, n);
  }, C[N.ASSET_HYPERLINK] = function (e) {
    return m(N.ASSET_HYPERLINK, e);
  }, C[N.ENTRY_HYPERLINK] = function (e) {
    return m(N.ENTRY_HYPERLINK, e);
  }, C[N.EMBEDDED_ENTRY] = function (e) {
    return m(N.EMBEDDED_ENTRY, e);
  }, C[N.HYPERLINK] = function (e, n) {
    return o.createElement("a", {
      href: e.data.uri
    }, n);
  }, C),
      v = ((I = {})[s.BOLD] = function (e) {
    return o.createElement("b", null, e);
  }, I[s.ITALIC] = function (e) {
    return o.createElement("i", null, e);
  }, I[s.UNDERLINE] = function (e) {
    return o.createElement("u", null, e);
  }, I[s.CODE] = function (e) {
    return o.createElement("code", null, e);
  }, I);

  function m(e, n) {
    return o.createElement("span", {
      key: n.data.target.sys.id
    }, "type: ", n.nodeType, " id: ", n.data.target.sys.id);
  }

  e.documentToReactComponents = function (e, n) {
    return void 0 === n && (n = {}), e ? K(e, {
      renderNode: _a(_a({}, y), n.renderNode),
      renderMark: _a(_a({}, v), n.renderMark),
      renderText: n.renderText
    }) : null;
  };
}(u);

var l = function l(n) {
  var t = n.content,
      r = n.options;

  if (t) {
    var o = t.json;
    return o ? e.createElement(e.Fragment, null, u.documentToReactComponents(o, r)) : e.createElement(e.Fragment, null);
  }

  return e.createElement(e.Fragment, null);
};

export { a as EmbeddedBlock, r as RichText, l as RichTextReact };